module.exports = __webpack_public_path__ + "static/johnstone-logo-cffbe3045467a45bb759da9da37c7609.png";